import { FormattedMessage } from 'react-intl'

import { useIsOnboardingBlocked, useServiceType } from '@hooks'

import { ServiceTypeSwitch } from '@components/ServiceTypeSwitch'

import { ROUTES } from '@constants'

import { CashFlowNavLinks } from './CashFlowNavLinks'
import { PartnersNavLinks } from './PartnersNavLinks'
import { TransactionsNavLink } from './TransactionsNavLink'

import { CompanyDocumentsPageMessage } from '@messages'
import { LinkSpan, StyledNavLink } from '../styles'

interface MainMenuProps {
  hasSubscription: boolean
}

export function MainMenu({ hasSubscription }: MainMenuProps) {
  const blockedByOnboarding = useIsOnboardingBlocked()
  const serviceType = useServiceType()

  return (
    <>
      <StyledNavLink to={ROUTES.pulse} noSubscription={!hasSubscription}>
        <LinkSpan>
          <ServiceTypeSwitch
            autotax={<FormattedMessage id="navLink.overview" defaultMessage="Áttekintés" />}
            quickkeret={<FormattedMessage id="navLink.reports" defaultMessage="Pulzus" />}
          />
        </LinkSpan>
      </StyledNavLink>
      <TransactionsNavLink hasSubscription={hasSubscription} blockedByOnboarding={blockedByOnboarding} />

      <PartnersNavLinks hasSubscription={hasSubscription} blockedByOnboarding={blockedByOnboarding} />
      <CashFlowNavLinks hasSubscription={hasSubscription} blockedByOnboarding={blockedByOnboarding} />
      {serviceType === 'autotax' && (
        <>
          <StyledNavLink to={ROUTES.taxationDetails} blockedByOnboarding={blockedByOnboarding}>
            <LinkSpan>
              <FormattedMessage id="navLink.taxationDetails" defaultMessage="Adózási adatok" />
            </LinkSpan>
          </StyledNavLink>
          <StyledNavLink
            blockedByOnboarding={blockedByOnboarding}
            to={ROUTES.companyDocuments}
            noSubscription={!hasSubscription}
          >
            <LinkSpan>{CompanyDocumentsPageMessage}</LinkSpan>
          </StyledNavLink>
        </>
      )}
    </>
  )
}
